export default __webpack_public_path__ + "static/media/dashboardPages.e7ee944d.svg";